module.exports = __webpack_public_path__ + "static/media/down.2329faab.svg";